// material-ui
import { Fab, Badge, IconButton, useTheme } from '@mui/material';

// project-imports
import { useDTDevelopment } from 'contexts/DTDevelopmentContext';

// assets
import { Buildings } from 'iconsax-react';

interface Props {
  onClick: () => void;
}

// ==============================|| DT DEVELOPMENT - FLOATING BUTTON ||============================== //

export default function FloatingDTDevelopment({ onClick }: Props) {
  const theme = useTheme();

  const { getDTDevelopmentItemCount } = useDTDevelopment();

  return (
    <Fab
      size="large"
      variant="circular"
      sx={{
        borderRadius: 0,
        borderTopLeftRadius: '50%',
        borderBottomLeftRadius: '50%',
        borderTopRightRadius: '4px',
        borderBottomRightRadius: '4px',
        top: '10%',
        position: 'fixed',
        right: 0,
        zIndex: theme.zIndex.speedDial,
        boxShadow: theme.customShadows.z1,
        bgcolor: 'background.paper',
        border: '4px solid ',
        borderColor: 'background.paper',
        borderRight: 'none',
        '&:hover': {
          bgcolor: 'primary.lighter'
        }
      }}
      onClick={onClick}
    >
      <IconButton
        component="span"
        aria-label="offer toggler"
        size="large"
        sx={{
          p: 0,
          color: 'primary.dark',
          '& svg': { width: 26, height: 26 },
          '&:hover': {
            bgcolor: 'transparent'
          }
        }}
        color="primary"
      >
        <Badge badgeContent={getDTDevelopmentItemCount()} color="primary">
          <Buildings variant="Bulk" />
        </Badge>
      </IconButton>
    </Fab>
  );
}
